import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "../elements/icon";

const { string, bool, func, any } = PropTypes;

class InputControlsWrap extends Component {
  static propTypes = {
    icon: string, // left side icon (optional)
    disabled: bool, // disables the clear icon entirely
    hasValue: any, // determines if the clear icon can be clicked
    onClear: func, // what to do when the clear icon is clicked
    width: any,
    children: any, // should be an <input> or something that returns an <input>
    error: any,
    forwardedRef: any,
  };

  static defaultProps = {
    messageTimeout: 500,
    width: "100%",
  };

  render() {
    const { icon, disabled, onClear, hasValue, children } = this.props;

    const { error } = this.props;

    return (
      <span
        ref={this.props.forwardedRef}
        style={{ width: this.props.width }}
        className={classNames("et--clearable-input", {
          "has-error": error,
          "has-icon": icon,
          "has-clear-icon": onClear,
        })}
      >
        {children}

        {icon && <Icon icon={icon} className="et--clearable-input--icon" />}

        {onClear && !disabled && (
          <Icon
            className={classNames("et--clearable-input--clear-icon", {
              "is-disabled": !hasValue,
            })}
            icon="cancel"
            onClick={onClear}
            disabled={!hasValue}
          />
        )}
      </span>
    );
  }
}

export default React.forwardRef((props, ref) => <InputControlsWrap {...props} forwardedRef={ref} />);
